<div class="d-flex wrapper" [title]="'Views' | localize">
    <span>
        <i class="fas fa-eye"></i>
    </span>
    <span class="count">
        {{viewsCount}}
    </span>
</div>
